import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import type SessionUserService from 'volta/services/session-user';
import type User from 'volta/models/user';

export interface MeHelperSignature {
  Return: User;
}

export default class MeHelper extends Helper<MeHelperSignature> {
  @service sessionUser!: SessionUserService;

  compute() {
    return this.sessionUser.user;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    me: MeHelper;
  }
}
